import { useState } from 'react';
import { authPostRequest } from 'Api/api';
import SuccessError from 'components/SuccessError';
import { useSelector } from 'react-redux';
import ModalComp from 'components/Modal';
import PropTypes from 'prop-types';
import Loader from 'components/Loader';
import CenteredWrapper from 'pages/updatePassword/CenteredWrapper';
import { ValidateFields } from 'pages/BracketPricePages/ValidateFields';
import BracketPriceForm from 'components/BracketPriceForm';

const initialBracketState = {
  name: '',
  wholesalePrice: '',
  contractorPrice: '',
  manufacturerPrice: '',
  retailerPrice: '',
  type: null,
  material: null
};

const CreateAndUpdateBracketPrice = ({
  bracket,
  addOpenModal,
  setAddOpenModal,
  setSuccess,
  setAlertBar,
  setIsFormSaved,
  isFormSaved
}) => {
  const [showLoader, setShowLoader] = useState(false);
  const [showAlertBar, setShowAlertBar] = useState(false);

  // state will be empty in case of add object
  const [bracketInfo, setBracketInfo] = useState({
    name: bracket.bracketId ? bracket?.name : '',
    wholesalePrice: bracket.bracketId ? bracket?.wholesalePrice : '',
    contractorPrice: bracket.bracketId ? bracket?.contractorPrice : '',
    manufacturerPrice: bracket.bracketId ? bracket?.manufacturerPrice : '',
    retailerPrice: bracket.bracketId ? bracket?.retailerPrice : '',
    type: bracket.bracketId ? bracket?.bracketTypeId : '',
    material: bracket.bracketId ? bracket?.materialTypeId : ''
  });

  const [successMessage, setSuccessMessage] = useState([]);
  const [errorMessage, setErrorMessage] = useState([]);
  const [errors, setErrors] = useState({});

  const { userData } = useSelector((store) => store.auth);

  const handleBracketInfo = (e) => {
    setBracketInfo({ ...bracketInfo, [e.target.name]: e.target.value });
    handleError(e.target.name, null);
  };

  const handleError = (input, errorMessage) => {
    setErrors((prevState) => ({ ...prevState, [input]: errorMessage }));
  };

  //save and add more
  const saveAndAddMore = async (e) => {
    e.preventDefault();
    setSuccess([]);
    setErrorMessage([]);
    const createBracketPrice = await handleSubmit();
    if (createBracketPrice?.resStatus === 1) {
      setIsFormSaved(!isFormSaved);
      setSuccessMessage([createBracketPrice?.resMessage]);

      setBracketInfo(initialBracketState);
    }

    if (createBracketPrice?.resStatus === 0) {
      setErrorMessage([createBracketPrice?.resMessage]);
    }
  };

  //Save and close
  const saveAndClose = async (e) => {
    e.preventDefault();
    setErrorMessage([]);
    setSuccess([]);
    setAlertBar(false);
    const createBracketPrice = await handleSubmit();

    if (createBracketPrice?.resStatus === 1) {
      setIsFormSaved(!isFormSaved);
      setSuccess([createBracketPrice?.resMessage]);

      setBracketInfo(initialBracketState);
      setAddOpenModal(false);
    }

    if (createBracketPrice?.resStatus === 0) {
      setErrorMessage([createBracketPrice?.resMessage]);
    }

    setAlertBar(true);
    window.scrollTo(0, 0);
  };

  const handleSubmit = async () => {
    setErrorMessage([]);
    setSuccessMessage([]);
    console.log('bracketInfo', bracketInfo);
    const isFormValid = ValidateFields(bracketInfo, handleError);
    try {
      const requestParams = {
        userId: userData.userId,
        bracketId: bracket?.bracketId ? bracket?.bracketId : '',
        name: bracketInfo.name,
        bracketTypeId: bracketInfo.type,
        materialTypeId: bracketInfo.material,
        wholesalePrice: bracketInfo.wholesalePrice,
        contractorPrice: bracketInfo.contractorPrice,
        manufacturerPrice: bracketInfo.manufacturerPrice,
        retailerPrice: bracketInfo.retailerPrice
      };

      setShowLoader(true);
      setShowAlertBar(false);
      const createBracketPrice =
        isFormValid && (await authPostRequest('saveBracket', requestParams));

      setShowLoader(false);
      setShowAlertBar(true);
      return createBracketPrice;
    } catch (err) {
      setErrorMessage([...errorMessage, 'Error']);
      window.scrollTo(0, 0);
    }
  };

  return (
    <CenteredWrapper>
      <ModalComp
        modalWidth={600}
        open={addOpenModal}
        setOpen={setAddOpenModal}
        header={bracket?.bracketId ? 'Update Bracket' : 'Create Bracket'}>
        {showAlertBar && (
          <SuccessError
            successMessage={successMessage}
            errorMessage={errorMessage}
            setShowAlertBar={setShowAlertBar}
          />
        )}

        {showLoader && <Loader open={showLoader} />}

        <BracketPriceForm
          handleSubmit={saveAndAddMore}
          buttonText="Save & Add More"
          buttonClose="Save & Close"
          handleError={handleError}
          handleCancelAction={saveAndClose}
          handleBracketInfo={handleBracketInfo}
          bracketInfo={bracketInfo}
          error={errors}
          bracket={bracket}
        />
      </ModalComp>
    </CenteredWrapper>
  );
};

CreateAndUpdateBracketPrice.propTypes = {
  bracket: PropTypes.object,
  addOpenModal: PropTypes.bool,
  setAddOpenModal: PropTypes.func,
  isFormSaved: PropTypes.bool,
  setIsFormSaved: PropTypes.func,
  setSuccess: PropTypes.func,
  setAlertBar: PropTypes.func
};

export default CreateAndUpdateBracketPrice;
